import React from "react"

const QpBackTopPanel = ({ fillColor, strokeColor }) => (
  <g id="back-top-panel">
    <path fill={fillColor} d="M438.3 264.1c0-28.7 10.3-154.4-61.5-176.8-121.8-38.1-187-46-231.2-50.4C77.1 30 51 33.1 27 56-3 84.5 2 173 2 173l1.3 61.2L8.2 294S3.3 147.3 4 117v-.1c.2-6.8.5-9.7 1.5-12.5 13.1-36.3 35.2-42.8 35.2-42.8 16.8-2.6 33.8-2.8 50.7-.6C336.1 92.3 376.7 123.8 384 171c5.8 29.1 7.2 43.5 7.2 62.3 5.7 68.2-1 148.9-1 148.9 28.6 6.8 44.9-7.7 44.9-7.7s3.2-81.7 3.2-110.4Z" fillRule="nonzero"/>
    <g stroke={strokeColor} strokeLinecap="round" strokeLinejoin="round">
      <path d="M438.3 264.1c0-28.7 10.3-154.4-61.5-176.8-121.8-38.1-187-46-231.2-50.4C77.1 30 51 33.1 27 56-3 84.5 2 173 2 173l1.3 61.2L8.2 294S3.3 147.3 4 117v-.1c.2-6.8.5-9.7 1.5-12.5 13.1-36.3 35.2-42.8 35.2-42.8 16.8-2.6 33.8-2.8 50.7-.6C336.1 92.3 376.7 123.8 384 171c5.8 29.1 7.2 43.5 7.2 62.3 5.7 68.2-1 148.9-1 148.9 28.6 6.8 44.9-7.7 44.9-7.7s3.2-81.7 3.2-110.4Z" strokeWidth="3" strokeMiterlimit="10"/>
    </g>
  </g>
)

export default QpBackTopPanel
